interface Params {
  fileName: string;
  href: string;
}

export function downloadFile({ fileName, href }: Params): void {
  const downLoadUrl = document.createElement("a");
  downLoadUrl.href = href;
  downLoadUrl.download = fileName;
  downLoadUrl.target = "_blank";
  downLoadUrl.click();
}
